(function () {
  function bindGuide(guide) {
    if (!guide || guide.dataset.vzBound === '1') return;
    guide.dataset.vzBound = '1';
    var dialog = guide.querySelector('[data-vz-size-dialog]');
    var openBtn = guide.querySelector('[data-vz-size-open]');
    var closeBtn = guide.querySelector('[data-vz-size-close]');
    var tabs = guide.querySelectorAll('[data-vz-size-tab]');
    var panels = guide.querySelectorAll('[data-vz-size-panel]');
    if (!dialog || !openBtn) return;

    openBtn.addEventListener('click', function () {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    });

    function close() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }

    if (closeBtn) closeBtn.addEventListener('click', close);
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) close();
    });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-vz-size-tab');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-vz-size-panel') === id;
          p.classList.toggle('is-active', on);
          p.hidden = !on;
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-vz-size-guide]').forEach(bindGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
